import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase/firebase'; // Import Firestore instance from firebase.js
import '../assets/css/CourseContainer.css'; // Import CSS file for component styling

const CourseContainer = () => {
  const courses = [
    'General Nursing',
    'Midwifery',
    'Biomedical Engineering (HND)',
    'Biomedical Engineering (ND)',
    'School of Community Health',
    'Anaesthetic Technicians',
    'Medical And Psychiatric Social Work',
    'Health Information Management (ND)',
    'Health Information Management (HND)',
    'Accident & Emergency Program',
    'Ophthalmic Program',
    'Paediatric Program',
    'Perioperative Program'
  ];

  const [registrationCounts, setRegistrationCounts] = useState({});

  useEffect(() => {
    const fetchRegistrationCounts = async () => {
      try {
        const snapshot = await firestore.collection('Registrations').get();
        const counts = {};
        courses.forEach(course => {
          counts[course] = 0;
        });

        snapshot.forEach(doc => {
          const data = doc.data();
          const { course, status, submitted } = data;

          if (status === 'Completed' && courses.includes(course) && submitted === true) {
            counts[course] += 1;
          }
        });

        setRegistrationCounts(counts);
      } catch (error) {
        console.error('Error fetching registration counts:', error);
      }
    };

    fetchRegistrationCounts();
  }, 
 );

  return (
    <div className="course-container">
      {Object.keys(registrationCounts).map(course => (
        <div key={course} className="course-card">
          <div className="card-content">
            <div className="course-name">{course}</div>
            <div className="completed-registrations">
              {registrationCounts[course]}
              <span className="registration-label"></span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CourseContainer;
